import { render, staticRenderFns } from "./merchandising.vue?vue&type=template&id=ef685c44&"
import script from "./merchandising.vue?vue&type=script&lang=js&"
export * from "./merchandising.vue?vue&type=script&lang=js&"
import style0 from "./merchandising.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports